import { AuthService } from "../services/auth.service";
import { ActivatedRouteSnapshot, Router, UrlTree, RouterStateSnapshot } from "@angular/router";
import { AppURL } from "../app.url";
import { inject } from "@angular/core";

/** Authentication guard — ยังไม่ login ให้ไปหน้า login แล้วกลับมาหน้าเดิม */
export function AuthGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (inject(AuthService).isLoggedIn) return true;
    return inject(Router).createUrlTree(['/', AppURL.login], { queryParams: { redirect: state.url } });
};

/** Authentication guard for not login routing — login แล้วไม่ต้องเห็นหน้า login */
export function UnAuthGuard(): boolean | UrlTree {
    if (!inject(AuthService).isLoggedIn) return true;
    return inject(Router).createUrlTree(['/']);
}
